import { render, staticRenderFns } from "./courtsProfile.vue?vue&type=template&id=fd030f2e"
import script from "./courtsProfile.vue?vue&type=script&lang=js"
export * from "./courtsProfile.vue?vue&type=script&lang=js"
import style0 from "./courtsProfile.vue?vue&type=style&index=0&id=fd030f2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports